"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mobileGoFullscreen = exports.gameGoFullscreen = exports.game = exports.config = exports.getDevicePixelRatio = void 0;
var voyageScene_sidecar_1 = require("@voyage/scene/voyageScene-sidecar");
require("phaser");
var crokinoleScene_sidecar_1 = require("proto/crokinole/scene/crokinoleScene-sidecar");
var minigolfScene_sidecar_1 = require("proto/minigolf/scene/minigolfScene-sidecar");
var perf_sidecar_1 = require("../engine/perf-sidecar");
var pubSub_sidecar_1 = require("../engine/pubSub-sidecar");
var common_sidecar_1 = require("./common-sidecar");
var loadingScreen_sidecar_1 = require("./loadingScreen-sidecar");
var preloader_sidecar_1 = require("./preloader-sidecar");
// const gameMode: GameMode = 'voyage'
// const gameMode: GameMode = 'chess'
//const gameMode: GameMode = 'golf'
// const gameMode: GameMode = 'crokinole' as GameMode
var gameMode = 'minigolf-rl-2024';
//const gameMode: GameMode = 'voyage' as GameMode
var transparent = false;
var backgroundColor = '#191324';
if (gameMode === 'crokinole') {
    transparent = true;
}
if (gameMode === 'minigolf-rl-2024') {
    // transparent = true
}
var pixelArt = false;
if (gameMode === 'goat') {
    pixelArt = true;
}
// import { ShaderHighlightPipeline2 } from '../pipeline/ShaderHighlightPipeline2'
var getDevicePixelRatio = function () {
    return window.devicePixelRatio || 1;
};
exports.getDevicePixelRatio = getDevicePixelRatio;
var w = window.innerWidth;
var h = window.innerHeight;
exports.config = {
    type: Phaser.WEBGL,
    scale: {
        mode: Phaser.Scale.NONE,
        width: window.innerWidth * exports.getDevicePixelRatio(),
        height: window.innerHeight * exports.getDevicePixelRatio(),
        zoom: 1 / exports.getDevicePixelRatio(), // Set the zoom to the inverse of the devicePixelRatio
    },
    // mode: Phaser.NONE,
    //backgroundColor: '#0c1013', //'#191324',
    // backgroundColor: '#191970', //'#191324',
    // transparent: true,
    backgroundColor: backgroundColor,
    transparent: transparent,
    disableContextMenu: true,
    // width: w,
    // height: h,
    // width: w * getDevicePixelRatio(),
    // height: h * getDevicePixelRatio(),
    scene: {
        preload: preload,
        create: create,
        update: update,
        pack: {
            files: [
            // {
            //   type: 'scenePlugin',
            //   key: 'SpinePlugin',
            //   url: 'plugins/SpinePlugin.js',
            //   sceneKey: 'spine',
            // },
            ],
        },
    },
    parent: 'phaser-root',
    pixelArt: pixelArt,
    input: {
        gamepad: true,
    },
    pipeline: {
    // [ShaderHighlightPipeline2.KEY]: ShaderHighlightPipeline2,
    // HueRotatePipelinePostFX,
    // MosaicPipelinePostFX,
    // DiamondWipePipelinePostFX,
    },
};
exports.game = new Phaser.Game(exports.config);
function resize() {
    var w = window.innerWidth * exports.getDevicePixelRatio();
    var h = window.innerHeight * exports.getDevicePixelRatio();
    exports.game.scale.resize(w, h);
    exports.game.scale.setZoom(1 / exports.getDevicePixelRatio());
    // game.scale.setParentSize(w, h)
    // game.canvas.width = w
    // game.canvas.height = h
    // game.canvas.style.width = w + 'px'
    // game.canvas.style.height = h + 'px'
    pubSub_sidecar_1.pubSub.emit('browser:resize', {
        w: w,
        h: h,
    });
    // hideAddressBar()
}
window.addEventListener('resize', function (event) {
    resize();
}, false);
document.addEventListener('fullscreenchange', function (event) {
    setTimeout(function () {
        resize();
    }, 100);
});
// function hideAddressBar() {
//   if (getDevicePixelRatio() !== 1) {
//     if (
//       document.documentElement.scrollHeight <
//       window.outerHeight / getDevicePixelRatio()
//     )
//       document.documentElement.style.height =
//         window.outerHeight / getDevicePixelRatio() + 10 + 'px'
//     setTimeout(() => {
//       window.scrollTo(1, 1)
//     }, 0)
//   } else {
//     setTimeout(() => {
//       window.scrollTo(0, 0)
//     }, 0)
//   }
// }
// window.addEventListener('orientationchange', function () {
//   hideAddressBar()
// })
function gameGoFullscreen() {
    exports.game.scale.startFullscreen();
}
exports.gameGoFullscreen = gameGoFullscreen;
// let _triedFullscreen = false
function mobileGoFullscreen() {
    //if (!_triedFullscreen) {
    // if (!game.scale.isFullscreen) {
    //   game.scale.startFullscreen({})
    // }
    //_triedFullscreen = true
    //}
}
exports.mobileGoFullscreen = mobileGoFullscreen;
function preload() {
    perf_sidecar_1.perf.mark('preload');
    common_sidecar_1.common.setPhaserScene(this);
    // let load = this.load
    loadingScreen_sidecar_1.loadingScreen.preload(this);
    preloader_sidecar_1.preloader.preloadAssets(this.load);
}
function create() {
    perf_sidecar_1.perf.mark('preload done');
    common_sidecar_1.common.setPhaserScene(this);
    resize();
    exports.game.canvas.oncontextmenu = function (ev) {
        ev.preventDefault();
    };
    if (gameMode === 'voyage') {
        voyageScene_sidecar_1.voyageScene.create();
    }
    if (gameMode === 'crokinole') {
        crokinoleScene_sidecar_1.crokinoleScene.create();
    }
    if (gameMode === 'minigolf-rl-2024') {
        minigolfScene_sidecar_1.minigolfScene.create();
    }
    // if (gameMode === 'chess') {
    //   chessScene.create()
    // }
    // if (gameMode === 'golf') {
    //   golfScene.create()
    // }
    // if (gameMode === 'goat') {
    //   goatScene.create()
    // }
    // if (gameMode === 'card') {
    //   cardScene.create()
    // }
}
function update(time, delta) {
    if (gameMode === 'voyage') {
        voyageScene_sidecar_1.voyageScene.update(time, delta);
    }
    if (gameMode === 'crokinole') {
        crokinoleScene_sidecar_1.crokinoleScene.update(time, delta);
    }
    if (gameMode === 'minigolf-rl-2024') {
        minigolfScene_sidecar_1.minigolfScene.update(time, delta);
    }
    // if (gameMode === 'chess') {
    //   chessScene.update(time, delta)
    // }
    // if (gameMode === 'golf') {
    //   golfScene.update(time, delta)
    // }
    // if (gameMode === 'goat') {
    //   goatScene.update(time, delta)
    // }
    // if (gameMode === 'card') {
    //   cardScene.update(time, delta)
    // }
}
